export const ESTADOS_ERROR_VALIDACION = [
  "ERROR",
  "API_KEY_REQUIRED",
  "API_KEY_INVALID",
  "VALIDATION_ERROR",
  "FIELD_REQUIRED",
  "INVALID_FORMAT",
  "INVALID_ENUM_VALUE",
  "VALIDACION_NOT_FOUND",
  "ADQUIRIENTE_REQUIRED",
  "DIGITO_VERIFICACION_INVALIDO",
  "DIVIPOLA_INVALIDA",
  "LISTA_RESTRICTIVA_RECHAZADA",
  "INTERNAL_ERROR",
  "INTERNAL_SERVER_ERROR",
  "INTERNAL_SERVER_ERROR_DETAIL"
];

export const ESTADOS_VALIDACION = [
  "EN_VALIDACION",
  "PENDIENTE_VALIDACION",
  "VALIDACION_ACTIVA_EXISTENTE"
];

export const ESTADOS_CORRECCION = [
  "REQUIERE_CORRECCION",
  "PENDIENTE_INFORMACION"
];

export const RECHAZADA = "RECHAZADA";
export const EXPIRADA = "EXPIRADA";
